export default __webpack_public_path__ + "static/media/photo2.d1f598fc.jpg";